export default __webpack_public_path__ + "static/media/_DSC7414.c0d8862b.jpg";